export const changeValueOfConfiguration = (value, setHook) =>{
   setHook(value);
}